import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';

import { LoginComponent } from './authentication/login/login.component';
import { RegisterComponent } from './authentication/register/register.component';
import { LoginstatusComponent } from './authentication/loginstatus/loginstatus.component';
// import { PrivacyPolicyComponent } from './authentication/privacy-policy/privacy-policy.component';
import { HomeComponent } from './landing/home/home.component';
import { OrderConfirmationComponent } from './shopping-cart/order-confirmation/order-confirmation.component';
import { ThankYouComponent } from './shopping-cart/thank-you/thank-you.component';
import { PaymentConfirmationComponent } from './payment-gateway/payment-confirmation/payment-confirmation.component';
import { PaymentReceiptComponent } from './payment-gateway/payment-receipt/payment-receipt.component';
import { PaymentCompletedMessageComponent } from './payment-gateway/payment-completed-message/payment-completed-message.component';
import { PaymentErrorMessageComponent } from './payment-gateway/payment-error-message/payment-error-message.component';
import { PaymentProcessingComponent } from './payment-gateway/payment-processing/payment-processing.component';
import { AlertScreenComponent } from './alert-screen/alert-screen.component';
import {AutoLoginComponent} from './auto-login/auto-login.component';
import {PathRecommendationComponent} from './path-recommendation/path-recommendation.component';
import { AutorenewConfirmationComponent } from './payment-gateway/autorenew-confirmation/autorenew-confirmation.component';
import { PaymentAutoRenewComponent } from './payment-gateway/payment-auto-renew/payment-auto-renew.component';
import { CannotregisterComponent } from './authentication/cannotregister/cannotregister.component';


const appRoutes: Routes = [
  { path: 'login', component: LoginComponent },
  { path: 'logout', component: LoginstatusComponent },
  { path: 'register', component: RegisterComponent },
  // { path: 'privacypolicy', component: PrivacyPolicyComponent },
  { path: 'cannotregister', component: CannotregisterComponent },
  { path: 'order', component: OrderConfirmationComponent},
  { path: 'thankyou', component: ThankYouComponent},
  { path: ':customerid/:promocode', component: HomeComponent },
  { path: 'payment', component: PaymentConfirmationComponent },
  { path: 'paymentresponse', component: PaymentConfirmationComponent },
  { path: 'receipt', component: PaymentReceiptComponent },
  { path: 'paymentmessage', component: PaymentCompletedMessageComponent },
  { path: 'paymenterrormessage', component: PaymentErrorMessageComponent },
  { path: 'paymentprocessing', component: PaymentProcessingComponent },
  { path: 'alert', component: AlertScreenComponent },
  { path: 'pathrecommendation', component: PathRecommendationComponent },
  { path: 'autorenew', component: PaymentAutoRenewComponent },
  { path: '**', redirectTo: 'home' },
  { path: 'auto-login', component: AutoLoginComponent }
];

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forRoot(
      appRoutes,
      { enableTracing: false }
    )
  ],
  exports: [
    RouterModule
  ],
  declarations: []
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// D:/Projects/Embla/dev/shop.embla.no/client.shop.embla.no/src/app/app-routing.module.ts